<template>
    <div id="carousel-home" class="carousel slide text-xs-center" data-ride="carousel" data-interval="0">
        <ol class="carousel-indicators hidden-md-down">
            <li data-target="#carousel-home" data-slide-to="0" class="active"></li>
            <li data-target="#carousel-home" data-slide-to="1"></li>
            <li data-target="#carousel-home" data-slide-to="2"></li>
        </ol>
        <div class="carousel-inner" role="listbox">
            <div class="carousel-item active">
                <img class="w-100" src="/static/home/slider1.jpg" alt="First slide">
                <div class="carousel-caption">
                    <h3>BIENVENIDOS</h3>
                    <h4>-</h4>
                    <p>Somos la plataforma online encargada <br /> de dinamizar al mercado autopartista</p>
                </div>
            </div>
            <div class="carousel-item">
                <img class="w-100" src="/static/home/slider2.jpg" alt="First slide">
                <div class="carousel-caption">
                    <p>¡Con WPO podés ser comprador y vendedor de</p>
                    <h3>todo tipo de autopartes!</h3>
                </div>
            </div>
            <div class="carousel-item">
                <img class="w-100" src="/static/home/slider3.jpg" alt="First slide">
                <div class="carousel-caption">
                    <p>Un espacio exclusivo para encontrar <br /> y ofrecer todo tipo de repuestos</p>
                    <h3>todo a un click de distancia…</h3>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'home-slider',
    
    data () {
        return {
            msg: 'Welcome to Your Vue.js App'
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .carousel-caption {
        bottom: 0;
        top: 20px;
    }
</style>



// WEBPACK FOOTER //
// Home-Slider.vue?16687a63